import React from 'react';
import { withTheme, ThemeProvider } from 'styled-components';
import Navigation from './Navigation';

var NavigationWithTheme = withTheme(Navigation);

var emptyTheme = {};

export default function (props) {
  return React.createElement(
    ThemeProvider,
    { theme: emptyTheme },
    React.createElement(NavigationWithTheme, props)
  );
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/navigation/dist/esm/components/js/NavigationWithTheme.js
// module id = 575
// module chunks = 0